import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiService } from 'app/services/api/api.service';



@Injectable()
export class OwnerShipService implements Resolve<any>
{

    local: any;
    ubigeo: any;
    routeParams: any;
    localOnChanged: BehaviorSubject<any>;

    localInProcessOnChanged: BehaviorSubject<any>;
    localCompletedOnChanged: BehaviorSubject<any>;
    localSignedOnChanged: BehaviorSubject<any>;
    localDiscardedOnChanged: BehaviorSubject<any>;


    constructor(private _http: HttpClient, private _apiService: ApiService)
    {

        this.localOnChanged = new BehaviorSubject({});
        this.localInProcessOnChanged = new BehaviorSubject({});
        this.localCompletedOnChanged = new BehaviorSubject({});

        this.localSignedOnChanged = new BehaviorSubject({});
        this.localDiscardedOnChanged = new BehaviorSubject({});



    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;
        return new Promise((resolve, reject) => {
            Promise.all([
                this.getPending(),
                this.getCompleted(),
                this.getSigned(),
                this.getDiscarded(),
                this.show()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }


    getPending(){
        return new Promise((resolve, reject) => {
            this._http.get(this._apiService.local.lead_pending())
            .map((res: any) => res.data)
                .subscribe((local: any) => {
                    this.local = local;
                    this.localInProcessOnChanged.next(this.local);
                    resolve(local);
                }, reject);


        });

    }

    getCompleted(){
        return new Promise((resolve, reject) => {
            this._http.get(this._apiService.local.lead_completed())
            .map((res: any) => res.data)
                .subscribe((local: any) => {
                    this.local = local;
                    this.localCompletedOnChanged.next(this.local);
                    resolve(local);
                }, reject);
        });
    }

    getSigned(){
        return new Promise((resolve, reject) => {
            this._http.get(this._apiService.local.lead_signed())
            .map((res: any) => res.data)
                .subscribe((local: any) => {
                    this.local = local;
                    this.localSignedOnChanged.next(this.local);
                    resolve(local);
                }, reject);
        });
    }

    getDiscarded(){
        return new Promise((resolve, reject) => {
            this._http.get(this._apiService.local.lead_discarded())
            .map((res: any) => res.data)
                .subscribe((local: any) => {
                    this.local = local;
                    this.localDiscardedOnChanged.next(this.local);
                    resolve(local);
                }, reject);
        });
    }

    show(){

        if ( this.routeParams.id  ){
            return new Promise((resolve, reject) => {
                this._http.get(this._apiService.local.read(this.routeParams.id))
                .map((res: any) => res.data)
                    .subscribe((local: any) => {
                        this.local = local;
                        this.localOnChanged.next(this.local);
                        resolve(local);
                    }, reject);
            });
        }
    }

    getDiffSteps(arr1: any[] = [], arr2: any [] = [3, 4, 5, 6, 7, 8]) {
        const _array =  arr1.filter(x => !arr2.includes(x)).concat(arr2.filter(x => !arr1.includes(x)));
        return this.getMinValue(_array);
    }
    private  getMinValue(arr: any []) {
        if ( arr.length > 0) {
            return arr.reduce(function (p, v) {
                return ( p < v ? p : v );
              });
        }
        return 0;
    }



}


